import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  makeStyles,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

// Hooks
import useLogin from '../../hooks/useLogin';

// Components
import { Title } from '../../components/Title';
import { Form } from '../../components/Form';
import { Footer } from '../../components/Footer';

// Img
import StoreImage from '../../assets/image/icono.png';
import AvatarMan from '../../assets/image/avatar-man.svg';
import BgLogin from '../../assets/image/bg-login.svg';

// Css
import './login.scss';
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  textField: {
    width: '100%',
  },
}));

const Login = () => {
  const { login, errorLogin, loadingLogin } = useLogin();
  const [showPassword, setShowPassword] = useState(false);
  const [dataForm, setDataForm] = useState({
    email: '',
    password: '',
  });

  const classForm = useStyles();

  const handleChange = (e) => {
    setDataForm({
      ...dataForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (value) => {
    login(value);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div className='login'>
      <div className='login_svg'>
        <img className='login_svg_bg' src={BgLogin} alt='Fondo Login' />
        <img className='login_svg_truck' src={StoreImage} alt='Tienda' />
      </div>
      <div className='login_content'>
        <img className='login_icon' src={AvatarMan} alt='Perfil' />
        <div className='login_title'>
          <Title size='xl'>BIENVENIDO</Title>
        </div>

        <Form onSubmit={handleSubmit}>
          {errorLogin && <Alert severity='error'>{errorLogin}</Alert>}
          <div className='login_form'>
            <FormControl
              className={clsx(classForm.margin, classForm.textField)}
              variant='outlined'
            >
              <InputLabel htmlFor='email'>Correo</InputLabel>
              <OutlinedInput
                id='email'
                type='email'
                value={dataForm.email}
                name='email'
                required
                onChange={handleChange}
                labelWidth={50}
              />
            </FormControl>

            <FormControl
              className={clsx(classForm.margin, classForm.textField)}
              variant='outlined'
            >
              <InputLabel htmlFor='password'>Contraseña</InputLabel>
              <OutlinedInput
                color='primary'
                id='password'
                type={showPassword ? 'text' : 'password'}
                value={dataForm.password}
                name='password'
                required
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={handleMouseDownPassword}
                      edge='end'
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={85}
              />
            </FormControl>

            <Button
              type='submit'
              variant='contained'
              color='primary'
              disabled={loadingLogin}
            >
              INICIAR
            </Button>

            <Link className='login_recoverPassword' to='/session/recover'>
              Recuperar Contraseña
            </Link>
          </div>
        </Form>
      </div>

      <Footer />
    </div>
  );
};

export default Login;
